export default function useDataConfiguration(props) {
  return {
    variables: {
      type: 'pms_global',
    },
  }
}
